/* Copyright (c) 2022-2025 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useState } from "react";
import { useDeleteResourceMutation } from "~/generated/graphql";
import { showError, showSuccess } from "~/services/toast";
import { removeFromApolloCache } from "~/tools";

type Props = {
  onSuccess: () => void;
};

export function useDeleteResource({ onSuccess }: Props) {
  const [id, setId] = useState("");
  const [deleteResourceMutation, { client, ...rest }] =
    useDeleteResourceMutation({
      onCompleted: (data) => {
        if (data.removeResource) {
          onSuccess();
          showSuccess(`Resource has been removed.`);
          removeFromApolloCache(client.cache, `Resource:${id}`, "resources");
        }
      },
      onError: (error) => {
        showError(error.message);
      },
    });

  async function deleteResource(resourceId: string) {
    setId(resourceId);
    await deleteResourceMutation({
      variables: {
        removeResourceId: resourceId,
      },
    });
  }

  return [deleteResource, { client, ...rest }] as const;
}
